import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/kangaroo/logo.svg";
import "../../../Homepage/Component/Homepage.css";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp, CornerDownRight, MoveRight } from "lucide-react";
import { div } from "framer-motion/client";
import arrow from "../../../assets/kangaroo/arrow-cropped.svg"
import Destinationcountry from "../../../services/Destinationcountry";
import { useQuery } from "@tanstack/react-query";


const Navbar = () => {
  
  const router = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(false);

 const toggleDropdown = (key) => {
  setOpenDropdown((prev) => ({
    ...prev,
    [key]: !prev[key], // toggle the specific dropdown
  }));
};

  console.log(showDropdown);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  console.log(showDropdown);
   const fetchCountryData = async () => {
  try {
    const response = await Destinationcountry.getList();

    return response;
  } catch (error) {
    console.error("Error fetching country data:", error);
    return null;
  }
};

   const { isPending, error, data: countrydata } = useQuery({
    queryKey: ['countryData'],
    queryFn: () => fetchCountryData(),
  })

  const mobileMenuItems = [
  
  {
    name: "STUDY ABROAD",
    key: "StudyAbroad",
   children: [
  ...(countrydata?.map((country) => ({
    name: country.name,
    path: `/innerpage/${country?.id}`,
  })) || []), // spread the mapped array, fallback to empty array
  { name: "Institution We Represent", path: "/institutionrepresent" }, // static item
],
  },
  {
    name: "TEST PREPARATION",
    key: "TestPreparation",
    path: "/testpreparation",
    children: [
      { name: "IELTS", path: "/testprep/ielts" },
      { name: "PTE", path: "/testprep/ielts" },
      { name: "Duolingo", path: "/testprep/ielts" },
      { name: "TOEFL", path: "/testprep/ielts" },
      { name: "GRE", path: "/testprep/ielts" },
      { name: "GMAT", path: "/testprep/ielts" },
    ],
  },
  {
    name: "RESOURCES",
    key: "Resources",
    children: [
      { name: "Study Abroad Facts", path: "/resources/abroadFact" },
      { name: "Sample Documents", path: "/resources/document" },
      { name: "Statement of Purpose", path: "/resources/sop" },
      { name: "Interview Preparation Guidelines", path: "/testpreparation" },
    ],
  },
  {
    name: "ABOUT",
    key: "About",
    children: [
      { name: "Who We Are", path: "/about/whoweare" },
      { name: "Milestone", path: "/about/milestone" },
      { name: "Partnership", path: "/about/partner" },
      { name: "CEO", path: "/about/aboutceo" },
    ],
  },
  {
    name: "CORPORATE",
    key: "Corporate",
    children: [
      { name: "Career", path: "/corporate/career" },
      { name: "Become Our Franchise", path: "/corporate/franchise" },
      { name: "Download Company Profile", path: null, isAction: true },
      { name: "KEF Intelligence", path: "/" },
      { name: "Smart Kampus", path: "/" },
      { name: "DMS", path: "/" },
      { name: "Brand Identity Guidelines", path: "/" },
    ],
  },
  { name: "BLOG", key: "Blog", path: "/blog" },
  { name: "EVENTS", key: "Events", path: "/events" },
  { name: "CONTACT", key: "Contact", path: "/contact" },
];


  console.log(countrydata)
  return (
    <nav
      className="navbar navbar-expand-lg sticky-top "
      style={{
        zIndex: 1000,
        background: "white",
        boxShadow: "0 0.5px 0 #687c8694",
      }}
    >
      <div
        className="container-fluid px-3 px-md-4 px-lg-5 py-1 "
        style={{ backgroundColor: "white" }}
      >
        <div className="row vw-100 align-items-center justify-content-between  mx-0">
          {/* Logo Column */}
          <div className="col-6 col-lg-2 px-0">
            <img
              src={logo}
              className="img-fluid"
              style={{
                maxHeight: "70px",
                height: "auto",
                width: "auto",
                cursor: "pointer",
              }}
              onClick={() => {
                router("/");
              }}
              alt="Logo"
            />
          </div>

          {/* Hamburger Menu Column - Visible on mobile/tablet */}
          <div className="col-6 custom-mobile px-0 text-end">
            <button
              className="border-0 bg-transparent"
              onClick={toggleMenu}
              style={{
                fontSize: "1.5rem",
                cursor: "pointer",
                padding: "0.5rem",
                zIndex: 1001,
              }}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "2px",
                      background: "#6c757d",
                      transform: "rotate(45deg)",
                      top: "11px",
                    }}
                  ></div>
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "2px",
                      background: "#6c757d",
                      transform: "rotate(-45deg)",
                      top: "11px",
                    }}
                  ></div>
                </div>
              ) : (
                <div
                  style={{
                    width: "24px",
                    height: "18px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      background: "#6c757d",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      background: "#6c757d",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      background: "#6c757d",
                    }}
                  ></div>
                </div>
              )}
            </button>
          </div>

          {/* Desktop Menu Column - Hidden on mobile/tablet */}
        <div
  className="col-lg-10 custom-desktop px-0"
  style={{ backgroundColor: "transparent" }}
>
  <div className="row align-items-center justify-content-end mx-0 flex-nowrap">
    <div
      className="col-auto px-xl-3 px-lg-2 px-1"
      style={{ position: "relative" }}
      onMouseEnter={() => setShowDropdown("StudyAbroad")}
      onMouseLeave={() => setShowDropdown(null)}
    >
      <Link
        to="/studyAbroad"
        className="navbar-item-font py-3"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        STUDY ABROAD
      </Link>
      {showDropdown === "StudyAbroad" && (
        <div className="nav-dropdown">
  {countrydata?.map((country, index) => (
    <React.Fragment key={country.id}>
      <Link
        to={`/innerpage/${country.slug}`}
        className="nav-dropdown-item"
      >
        {country.name}
      </Link>
      {/* Add <hr> except after the last item */}
      {index !== countrydata.length - 1 && <hr className="nav-hr mx-3" />}
    </React.Fragment>
  ))}

  {/* Static link if needed */}
  <hr className="nav-hr mx-3" />
  <Link to="/institutionrepresent" className="nav-dropdown-item">
    Institution We Represent
  </Link>
</div>

      )}
    </div>

    <div
      className="col-auto px-xl-3 px-lg-2 px-1"
      style={{ position: "relative" }}
      onMouseEnter={() => setShowDropdown("TestPreparation")}
      onMouseLeave={() => setShowDropdown(null)}
    >
      <Link
        to="/testpreparation"
        className="navbar-item-font py-3"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        TEST PREPARATION
      </Link>
      {showDropdown === "TestPreparation" && (
        <div className="nav-dropdown">
          <Link to="/testprep/ielts" className="nav-dropdown-item">
            IELTS
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/testprep/ielts" className="nav-dropdown-item">
            PTE
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/testprep/ielts" className="nav-dropdown-item">
            Duolingo
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/testprep/ielts" className="nav-dropdown-item">
            TOEFL
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/testprep/ielts" className="nav-dropdown-item">
            GRE
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/testprep/ielts" className="nav-dropdown-item">
            GMAT
          </Link>
        </div>
      )}
    </div>

    <div
      className="col-auto px-xl-3 px-lg-2 px-1"
      style={{ position: "relative" }}
      onMouseEnter={() => setShowDropdown("Resources")}
      onMouseLeave={() => setShowDropdown(null)}
    >
      <Link
        className="navbar-item-font py-3"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        RESOURCES
      </Link>
      {showDropdown === "Resources" && (
        <div className="nav-dropdown">
          <Link
            to="/resources/abroadFact"
            className="nav-dropdown-item"
          >
            Study Abroad Facts
          </Link>
          <hr className="nav-hr mx-3" />
          <Link
            to="/resources/document"
            className="nav-dropdown-item"
          >
            Sample Documents
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/resources/sop" className="nav-dropdown-item">
            Statement of Purpose
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/testpreparation" className="nav-dropdown-item">
            Interview Prepartion Guidelines
          </Link>
        </div>
      )}
    </div>

    <div
      className="col-auto px-xl-3 px-lg-2 px-1"
      style={{ position: "relative" }}
      onMouseEnter={() => setShowDropdown("About")}
      onMouseLeave={() => setShowDropdown(null)}
    >
      <Link
        className="navbar-item-font m-0 py-3"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        ABOUT
      </Link>
      {showDropdown === "About" && (
        <div className="nav-dropdown">
          <Link to="/about/whoweare" className="nav-dropdown-item">
            Who We Are
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/about/milestone" className="nav-dropdown-item">
            Milestone
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/about/partner" className="nav-dropdown-item">
            Partnership
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/about/aboutceo" className="nav-dropdown-item">
            CEO
          </Link>
        </div>
      )}
    </div>

    <div
      className="col-auto px-xl-3 px-lg-2 px-1"
      style={{ position: "relative" }}
      onMouseEnter={() => setShowDropdown("Corporate")}
      onMouseLeave={() => setShowDropdown(null)}
    >
      <Link
        className="navbar-item-font m-0 py-3"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        CORPORATE
      </Link>
      {showDropdown === "Corporate" && (
        <div className="nav-dropdown">
          <Link to="/corporate/career" className="nav-dropdown-item">
            Career
          </Link>
          <hr className="nav-hr mx-3" />
          <Link
            to="/corporate/franchise"
            className="nav-dropdown-item"
          >
            Become Our Franchise
          </Link>
          <hr className="nav-hr mx-3" />
          <p className="nav-dropdown-item m-0">
            Download Company Profle
          </p>
          <hr className="nav-hr mx-3" />
          <Link to="/" className="nav-dropdown-item">
            KEF Intelligence
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/" className="nav-dropdown-item">
            Smart Kampus
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/" className="nav-dropdown-item">
            DMS
          </Link>
          <hr className="nav-hr mx-3" />
          <Link to="/" className="nav-dropdown-item">
            Brand Identity Guidelines
          </Link>
        </div>
      )}
    </div>

    <div className="col-auto px-xl-3 px-lg-2 px-1">
      <Link
        to="/blog"
        className="navbar-item-font py-3"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        BLOG
      </Link>
    </div>

    <div className="col-auto px-xl-3 px-lg-2 px-1">
      <Link
        to="/events"
        className="navbar-item-font"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        EVENTS
      </Link>
    </div>

    <div className="col-auto px-xl-2 px-lg-1 px-1">
      <Link
        to="/contact"
        className="navbar-item-font"
        style={{
          textDecoration: "none",
          whiteSpace: "nowrap",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
      >
        CONTACT
      </Link>
    </div>

    <div className="col-auto ps-xl-2 ps-lg-1 pe-0">
      <button
        onClick={() => router("/freecounseling")}
        style={{
          background: "linear-gradient(to right, #7e1790, #d70a84)",
          color: "white",
          border: "none",
          borderRadius: "35px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
          fontSize: "clamp(0.6rem, 0.9375vw, 18px)",
        }}
        className="navbar-btn-font px-xl-3 px-lg-2 ms-xl-4 ms-lg-2"
      >
        GET FREE COUNSELLING
      </button>
    </div>
  </div>
</div>
        </div>
      </div>

      {/* Mobile Menu - Slides in from right */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: isMenuOpen ? 0 : "-100%",
          width: "80%",
          maxWidth: "400px",
          height: "100vh",
          background: "white",
          boxShadow: isMenuOpen ? "-2px 0 10px rgba(0,0,0,0.1)" : "none",
          transition: "right 0.3s ease-in-out",
          zIndex: 999,
          overflowY: "auto",
          padding: "80px 2rem 2rem",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div>
      {mobileMenuItems.map((item) => (
        <div key={item.key} style={{ marginBottom: "1rem" }}>
          {/* Main link */}
          <div
            onClick={() => toggleDropdown(item.key)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "1.1rem",
              borderBottom: "1px solid #e0e0e0",
              padding: "0.5rem 0",
              cursor: "pointer",
            }}
          >
            <span>{item.name}</span>
            <span
              style={{
                transition: "transform 0.3s ease",
                transform: openDropdown[item.key] ? "rotate(180deg)" : "rotate(90deg)",
              }}
            >
              {/* Chevron from lucide-react */}
              <ChevronUp stroke={openDropdown[item.key] ? "#7E1790" : "#FF4D1D"} />
            </span>
          </div>

          {/* Dropdown */}
          <AnimatePresence>
            {openDropdown[item.key] && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
                style={{ overflow: "hidden", paddingLeft: "0.5rem" }}
              >
                {item.children.map((child) => (
                  <div className="d-flex ">
{/* <MoveRight style={{color:"#7E1790", fontSize:"10px"}} /> */}
<img src={arrow} style={{width:"10%"}} alt="" />

                  <Link
                    key={child.name}
                    className="d-block text-muted py-1"
                    to={child.path}
                    style={{ textDecoration: "none" }}
                    onClick={closeMenu}
                  >
                    {child.name}
                  </Link>
                  
                  </div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
    <button
                  style={{
                    background: "linear-gradient(90deg, #7e1790, #d70a84)",
                    color: "white",
                    border: "none",
                    padding: "12px 24px",
                    borderRadius: "35px",
                    cursor: "pointer",
                    fontSize: "1rem",
                    marginTop: "1rem",
                  }}
                  onClick={closeMenu}
                >
                  GET FREE COUNSELLING
                </button>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay - Click to close menu */}
      {isMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 998,
          }}
          onClick={closeMenu}
        />
      )}
    </nav>
  );
};

export default Navbar;
